import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';


const AlertOptions = React.memo(({
  onClick,
  option,
  falseText,
  trueText,
  showFalse,
  showTrue,
  falseButtonCols,
  trueButtonCols,
}) => (
  <>
    <div className="alert-options alert-options-spacemaker" />
    <div className="alert-options">
      <div className="side-left">
        {
          showFalse && (
            <OptionButton
              className={`false-button false-button-${falseButtonCols}`}
              type="button"
              onClick={onClick}
              option={{
                option,
                boolean: false,
              }}
            >
              {falseText}
            </OptionButton>
          )
        }
      </div>
      <div className="side-right">
        {
          showTrue && (
            <OptionButton
              className={`true-button true-button-${trueButtonCols}`}
              type="button"
              onClick={onClick}
              option={{
                option,
                boolean: true,
              }}
            >
              {trueText}
            </OptionButton>
          )
        }
      </div>
    </div>
  </>
));


AlertOptions.propTypes = {
  onClick: PropTypes.func,
  // option needs to be any as it can be any shape of paramators for a callbacks
  /* eslint-disable-next-line react/forbid-prop-types */
  option: PropTypes.any,
  falseText: PropTypes.string,
  trueText: PropTypes.string,
  falseButtonCols: PropTypes.number,
  trueButtonCols: PropTypes.number,
  showFalse: PropTypes.bool,
  showTrue: PropTypes.bool,
};

AlertOptions.defaultProps = {
  falseText: 'Cancel',
  trueText: 'Confirm',
  falseButtonCols: 2,
  trueButtonCols: 2,
  showFalse: true,
  showTrue: true,
};

export {
  AlertOptions,
};
